import { axios } from './commons';

export default {
  getAlgos: (id, pageNo = 1) => axios.get(`/users/${id}/algos?page=${pageNo}`),
  getAlgoById: (id, algoId) => axios.get(`/users/${id}/algos/${algoId}`),
  getAlgoConfig: () => axios.get(`/algos/config`),
};
